import { CurrencyPipe } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { PlautoService } from '@amfam/policy/data-access';
import { PolicyUtilService } from '@amfam/policy/e-signature/data-access';
import { AnalyticsFacade } from '@amfam/shared/analytics';
import { IQuotes, ISection } from '@amfam/shared/models';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService, UtilService } from '@amfam/shared/utility/shared-services';
import { DockingBarService, DsModalService, LoadingSpinnerService } from '@amfam/ui-kit';

import {
  AnalyticsEventType,
  ReplaceVehicleQuickQuoteOperation
} from '../+state/quick-quote-feature/quick-quote-enum';
import { QuickQuoteFeatureFacade } from '../+state/quick-quote-feature/quick-quote-feature.facade';
import { QuickQuoteComparisonComponent } from '../quick-quote-comparison/quick-quote-comparison.component';
import { QuickQuoteFeatureService } from '../services/quick-quote-feature.service';
import { ReviewQuoteContainerService } from './review-quote-container.service';

@Component({
  selector: 'review-quote-container',
  templateUrl: './review-quote-container.component.html',
  styleUrls: ['./review-quote-container.component.scss'],
  standalone: false
})
export class ReviewQuoteContainerComponent
  extends QuickQuoteComparisonComponent
  implements OnInit, AfterViewInit
{
  public exitFlowModalId = this.modalService.createModalId('exitFlowModalId');
  isPartner$ = this.store.select(BrandSelectors.selectIsPartner);
  futurePayments$: Observable<any> = this.quickQuoteFeatureFacade.futurePayments$;
  newVehicle$ = this.reviewQuoteContainerService.newVehicle$;
  replacedVehicle$ = this.reviewQuoteContainerService.replacedVehicle$;
  remainingVehicles$ = this.reviewQuoteContainerService.remainingVehicles$;
  quotes: IQuotes;
  policyCoverages$: Observable<ISection> = this.reviewQuoteContainerService.policyCoverages$;
  vehicleCoverages$: Observable<ISection> = this.reviewQuoteContainerService.vehicleCoverages$;
  discounts$: Observable<ISection> = this.reviewQuoteContainerService.discounts$;
  primaryButton$: Observable<string> = this.reviewQuoteContainerService.primaryButton$;

  constructor(
    protected quickQuoteFeatureFacade: QuickQuoteFeatureFacade,
    protected store: Store,
    protected spinnerService: LoadingSpinnerService,
    protected router: Router,
    protected copyService: CopyService,
    protected dockingBarService: DockingBarService,
    protected utilService: UtilService,
    protected route: ActivatedRoute,
    protected policyUtilService: PolicyUtilService,
    protected quickQuoteFeatureService: QuickQuoteFeatureService,
    protected autoPolicyService: PlautoService,
    protected reviewQuoteContainerService: ReviewQuoteContainerService,
    protected featureFlagService: FeatureFlagService,
    protected analyticsFacade: AnalyticsFacade,
    private modalService: DsModalService,
    protected currencyPipe: CurrencyPipe
  ) {
    super(
      quickQuoteFeatureFacade,
      store,
      spinnerService,
      router,
      copyService,
      dockingBarService,
      utilService,
      route,
      policyUtilService,
      quickQuoteFeatureService,
      reviewQuoteContainerService,
      featureFlagService,
      analyticsFacade,
      currencyPipe
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.quotes = this.reviewQuoteContainerService.transformPremium(this.premiumDetails);
    this.quickQuoteFeatureFacade.sendAnalytics(AnalyticsEventType.REPLACE_VEHICLE_NEW_PREMIUM);
    this.dockingBarService.registerHeading('Replace Vehicle');
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  back() {
    this.store.dispatch(fromRouterActions.Back());
  }

  sendToAgent(isCancelEvent = false) {
    this.quickQuoteFeatureFacade.setOperation(
      ReplaceVehicleQuickQuoteOperation.REPLACE_VEHICLE_COMPARE_QUOTE_SEND_TO_AGENT
    );

    const analyticsType = isCancelEvent
      ? AnalyticsEventType.REPLACE_VEHICLE_NEW_PREMIUM_CANCEL_SEND_TO_AGENT
      : AnalyticsEventType.REPLACE_VEHICLE_NEW_PREMIUM_SEND_TO_AGENT;
    this.quickQuoteFeatureFacade.sendAnalytics(analyticsType);
    this.analyticsFacade.trackEvent({
      event: 'agent_referral',
      form_name: 'Replace Vehicle'
    });

    this.quickQuoteFeatureFacade.sendToAgentOnCancel(isCancelEvent);
  }

  cancel() {
    this.modalService.open(this.exitFlowModalId);
    this.quickQuoteFeatureFacade.sendAnalytics(
      AnalyticsEventType.REPLACE_VEHICLE_NEW_PREMIUM_CANCEL
    );
  }

  stay() {
    this.modalService.close(this.exitFlowModalId);
  }

  leave() {
    this.store.dispatch(fromRouterActions.Go({ path: ['overview'] }));
  }
}
